<template>
	<div>
		<!-- 搜索框 -->
		<ul style="background: #fff;width: 100%;">
			<newTpSearch :hotState='false'></newTpSearch>
		</ul>
		<!-- 中心内容 -->
		<div class="MconBox d-rn d-ais d-jcs">
			<!-- 左侧==菜单分栏 -->
			<div class="MconBox-lftMenu">
				<ul class="MconBox-lftMenu-firstBox">
					全部功能
				</ul>
				<!-- 循环菜单 -->
				<ul class="MconBox-lftMenu-itemLi showHand  noSelectBox" v-for="(item,index) in leftMenu" :key='index'
					:style="{color:selMenuCurrent==index?'#E62129':'#333'}" @click="handleJumpPage(index)">
					{{item}}
				</ul>
			</div>
			<!-- 右侧===页面详情 -->
			<div class="MrgtBox">
				<!-- 页面详情 -->
				<ul class="MrgtBox-titBox d-flex d-aic">
					{{selMenuCurrent==0?'个人信息':
					selMenuCurrent==1?'我的订单':
					selMenuCurrent==3?'我的收货地址':
					selMenuCurrent==4?'我的收藏':
					selMenuCurrent==5?'我的优惠券':
					selMenuCurrent==6?'意见反馈':
					selMenuCurrent==7?'联系客服':
					selMenuCurrent==8?'关于我们':
					selMenuCurrent==9?'设置':
					selMenuCurrent==10?'企业认证':''}}
					<p class="my-new-state" v-if="selMenuCurrent==10 && my_state">({{my_state}})</p>
				</ul>
				
				<!-- 个人信息 -->
				<personalInfo v-if="selMenuCurrent==0"></personalInfo>
				<!-- 我的订单 -->
				<allOrder v-if="selMenuCurrent==1"></allOrder>
				<!-- 我的收货地址 -->
				<addressInfo v-if="selMenuCurrent==3"></addressInfo>
				<!-- 我的优惠券 -->
				<couponInfo v-if="selMenuCurrent==5"></couponInfo>
				<!-- 意见反馈 -->
				<feedbackInfo v-if="selMenuCurrent==6"></feedbackInfo>
				<!-- 联系客服 -->
				<serviceInfo v-if="selMenuCurrent==7"></serviceInfo>
				<!-- 关于我们 -->
				<mineInfo v-if="selMenuCurrent==8"></mineInfo>
				<!-- 设置 -->
				<setupInfo v-if="selMenuCurrent==9"></setupInfo>
				<!-- 企业认证 -->
				<enterpriseCertification v-if="selMenuCurrent==10"></enterpriseCertification>
			</div>
		</div>
	</div>
</template>

<script>
	import personalInfo from './components/personalInfo.vue'
	import newTpSearch from '../../components/newTpSearch.vue'
	import mineInfo from './components/mineInfo.vue'
	import serviceInfo from './components/serviceInfo.vue'
	import feedbackInfo from './components/feedbackInfo.vue'
	import setupInfo from './components/setupInfo.vue'
	import addressInfo from './components/addressInfo.vue'
	import couponInfo from './components/couponInfo.vue'
	import allOrder from './components/allOrder.vue'
	import enterpriseCertification from './components/enterprise-certification.vue'
	let _self;
	export default {
		name: 'MyInfo',
		data() {
			return {
				// 左侧菜单
				leftMenu: ['个人信息', '我的订单', '我的购物车', '地址管理', '我的收藏', '我的优惠券', '意见反馈', '联系客服', '关于我们', '设置','企业认证'],
				// 选中的菜单下标
				selMenuCurrent: 1,
				
				// 申请vip状态
				my_state:null,
				
				// 订单是否允许请求下一页
				orderNextState:false,
			}
		},
		beforeCreate() {
			_self = this;

		},
		created() {
			// 事件监听
			_self.handleAllEveJt();
			
			// 监听审核状态
			_self.$EventBus.$on('MyState',res=>{
				// console.log('我的审核状态-==========',res);
				_self.my_state = res
			})
			
			// 显示头底部导航栏
			this.$EventBus.$emit('AppCloseNav', true);


			// 获取本地存储中的菜单下标
			let leftCurrent = localStorage.getItem('menuCurrent');
			// 本地存储
			if (leftCurrent != null && leftCurrent >= 0) {
				// 有本地存储菜单下标===定义显示
				_self.selMenuCurrent = leftCurrent;
			} else {
				// 没有存储===跳转到个人信息页面
				_self.selMenuCurrent = 0;

				// 本地存储
				localStorage.setItem('menuCurrent', 0);
			}
			// console.log('页面名称===',_self.selMenuCurrent);
			// 定义页面title
			// _self.handleLetTitle(_self.selMenuCurrent);
		},
		// 方法集
		methods: {
			// 事件监听
			handleAllEveJt() {
				// 监听组件变化
				_self.$EventBus.$on('crtNum',res=>{
					// console.log('myinfo===下标变化',res);
					// 定义显示组件
					_self.selMenuCurrent=res;
				})
				// 判断订单是否还有下一页
				_self.$EventBus.$on('orderHasNext',res=>{
					// 定义请求下一页的状态
					_self.orderNextState=res;
				})
			},



			// 定义页面名称
			handleLetTitle(val){
				var titName;
				if(val==0){
					titName='个人信息';
				}else if(val==1){
					titName='我的订单';
				}else if(val==3){
					titName='地址管理';
				}else if(val==5){
					titName='优惠券';
				}else if(val==6){
					titName='意见反馈';
				}else if(val==7){
					titName='联系客服';
				}else if(val==8){
					titName='关于我们';
				}else if(val==9){
					titName='设置';
				}else if(val==10){
					titName='企业认证';
				}
				// console.log('修改tit===收到值了',titName);
				// 定义页面名称
				document.title=titName;
			},
			// 跳转页面
			handleJumpPage(val) {
				// 判断点击我的购物车页面
				if(val==2){
					// 跳转到购物车页面
					_self.$router.push('/ShopCar')
					return false;
				}
				// 我的收藏
				if(val==4){
					// 跳转到购物车页面
					_self.$router.push('/collection')
					return false;
				}
				
				
				// 重复点击
				if (val == _self.selMenuCurrent) return;

				//跳转===定义下标
				_self.selMenuCurrent = val;
				// 本地存储下标
				localStorage.setItem('menuCurrent', val);
				// 定义页面title
				_self.handleLetTitle(_self.selMenuCurrent);
			}
		},
		// 组件集
		components: {
			newTpSearch,
			personalInfo, //个人信息
			mineInfo, //关于我们
			serviceInfo, //联系客服
			feedbackInfo, //意见反馈
			setupInfo, //设置
			addressInfo, //地址管理
			couponInfo, //我的优惠券
			allOrder,	//我的订单
			enterpriseCertification, 		// 企业认证
		},
		mounted() {
			// 滚动到头部
			window.scrollTo({
			    left: 0,
			    top: 0,
			});
			// 定义页面背景色
			document.body.style.background = '#f5f5f5';

			// 定义title
			_self.handleLetTitle(_self.selMenuCurrent);
			
			
			// 监听页面滑动
			window.onscroll = function(){
				//变量scrollTop是滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
				//变量windowHeight是可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//变量scrollHeight是滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
				// 获取当前页面名称
				let pageName=_self.$router.history.current.name;
				//滚动条到底部的条件：  滑动距离+滑块高度大于侧边滚动条长度***最新的滚动条长度不等于上回的高度***允许加载下一页
				if( pageName=='MyInfo' && scrollTop+windowHeight==scrollHeight
				&& _self.orderNextState && _self.selMenuCurrent==1){
					// console.log('滑倒底部开始请求');
					// 不允许请求下一页====防止频繁请求
					_self.orderNextState=false;
					
					_self.$EventBus.$emit('orderRequestNext',true)
				}
			}
		},
		watch: {

		},
		computed: {

		},
		// 过滤器
		filters: {

		},
		// 实例销毁
		destroyed() {
			// localStorage.setItem('menuCurrent',0);
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
	}
</script>
<style lang="scss">
	/* 中心内容 */
	.MconBox {
		width: 1200px;
		// border: 1px solid red;
		min-height: 750px;
		margin: 0 auto 40px;
		padding-top: 30px;
		box-sizing: border-box;
		background: #f5f5f5;

		/* 左侧菜单 */
		&-lftMenu {
			width: 190px;
			height: 100%;

			// border: 1px solid yellow;
			&-firstBox {
				font-size: 24px;
				font-weight: 400;
				text-align: left;
				color: #333333;
				letter-spacing: 3px;
				margin-bottom: 30px;
			}

			/* 循环菜单 */
			&-itemLi {
				width: 100%;
				margin-bottom: 15px;

				font-size: 20px;
				font-weight: 400;
				text-align: left;
				letter-spacing: 2px;
			}
		}
	}

	/* 右侧详细页面 */
	.MrgtBox {
		flex: 1;
		overflow: hidden;
		height: 100%;

		// background: #FFFFFF;
		// margin-top: 15px;
		/* 页面详情 */
		&-titBox {
			width: 100%;
			background: #ffffff;
			padding: 20px;
			box-sizing: border-box;

			font-size: 20px;
			font-weight: 400;
			text-align: left;
			color: #000000;
			letter-spacing: 2px;
			margin-bottom: 15px;
		}
	}
	.my-new-state{
		margin-left: 100px;
		color: #969393;
	}
</style>
